import React from 'react';
import { BEHANCE, GITHUB, services, skills } from '../data';
import Arrow from '../components/Arrow';
import Snapshots from '../components/Snapshots';
import './About.css';

export default function About() {
  return (
    <main className="about">
      <div className="shell">
        <div className="meta-row fade-in">
          <span className="meta">Profile</span>
          <span className="meta">Lagos · Nigeria</span>
        </div>

        <h1 className="display about-title">
          <span className="mask"><span>About</span></span>
        </h1>

        <p className="about-lead fade-in" style={{ '--d': 2 }}>
          I'm Temitope Abodunrin, a software engineer and designer based in Lagos, Nigeria. I care about building
          clean, efficient and scalable web applications that solve real problems.
        </p>
        <p className="about-body fade-in" style={{ '--d': 3 }}>
          Beyond engineering, I bring a creative edge as a designer with experience in logos, branding campaigns and
          digital design. I'm open to freelance and full-time roles, and to teams where I can grow as both an engineer
          and a creative professional.
        </p>

        <div className="about-actions fade-in" style={{ '--d': 4 }}>
          <a className="btn btn-solid" href="#/contact">Start a project <Arrow /></a>
          <a className="btn" href="#/work">See the work <Arrow /></a>
        </div>

        <section className="about-block">
          <p className="meta about-label rv">What I do</p>
          <ul className="about-roles">
            {services.map(s => (
              <li key={s.title} className="rv">
                <span className="display">{s.title}</span>
                <span className="meta">{s.note}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="about-block">
          <div className="meta-row about-label rv">
            <span className="meta">What I work with</span>
            <span className="meta">{String(skills.length).padStart(2, '0')}</span>
          </div>
          <dl className="about-stack">
            {skills.map(g => (
              <div key={g.label} className="rv">
                <dt className="meta">{g.label}</dt>
                <dd>{g.items.join(' · ')}</dd>
              </div>
            ))}
          </dl>
          <p className="about-aside rv">
            The code lives on <a href={GITHUB} target="_blank" rel="noreferrer">GitHub</a>, the design on{' '}
            <a href={BEHANCE} target="_blank" rel="noreferrer">Behance</a>.
          </p>
        </section>
      </div>

      <Snapshots />
    </main>
  );
}
